export { MemberCompanyDirectoryHit } from './MemberCompanyDirectoryHit';
